import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChatBotComponent } from '../chat-bot.component';
import { ChatBotService } from '../services/chat-bot.service';

@Component({
  selector: 'tm-chats',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.scss'],
  providers: [ChatBotService]

})
export class ChatsComponent implements OnInit, OnChanges {

  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label_code;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form_group;
  @Input() form_control;
  @Input() label;
  @Input() maxLength;
  @Input() label_block;
  @Input() minLength;
  @Input() maxValue;
  @Input() minValue;
  @Input() prefix_label;
  @Input() suffix_label;
  @Input() label_class;
  @Input() disabled;
  @Input() step;
  @Input() readonly_view = 0;
  @Input() refId;
  @Input() result = []
  @Input() username
  @Input() heading
  @Input() hide_label;
  @Input() id_property = 'alertId';
  @Input() disable_dynamic_message_loading = 0;
  @Output() messageChange = new EventEmitter<any>();
  list = [];

  @Input() view_type = 1;
  random_id = 'number' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  @Input() multi_notes: any;

  constructor(
    private dialog: MatDialog,
    private api: ChatBotService,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      try {
        this.form_group.patchValue(this.form_group.value);
      }
      catch (err) {

      }
    });
  }
  ngOnChanges(ev) {
    if (ev && ev.refId) {
      let ref = ev.refId.currentValue;
      if (typeof ref == "object" && ref && ref.length) {
        this.view_type = 2;
        this.list = ref;
        this.refId = ref.map(data => data[this.id_property]);
      }
      else {
        this.view_type = 2;
        this.refId = ev.refId.currentValue;
      }

      if (!ref || ref == 0) {
        this.view_type = 1;
      }
      if (!this.disable_dynamic_message_loading && this.refId > 0) {
        this.api.getMessages({
          type: this.type,
          refId: this.refId
        }).subscribe(res => {
          if (res && res['data']) {
            this.result = res['data'].list || []
          }
        })
      }
    }
    if (ev && ev.result) {
      this.result = ev.result.currentValue;
    }
    if (ev && ev.result) {
      this.result = ev.result.currentValue;
    }
    if (ev && ev.view_type) {
      this.view_type = ev.view_type.currentValue;
    }
  }
  openChat() {
    this.dialog.open(ChatBotComponent, {
      width: '40%',
      disableClose: true,
      data: {
        type: this.type,
        refId: this.refId,
        heading: this.heading,
        result: this.result,
        list: this.list,
        view_type: this.view_type,
        multi_notes: this.multi_notes
      },
      panelClass: "TM-Dialog",
    }).afterClosed().subscribe(res => {
      if (res) {
        if (res) {
          this.result = res || []
          this.messageChange.emit(this.result)
        }
      }
    })
  }

}
